"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberAttitudeScaleInput = void 0;
var react_1 = __importDefault(require("react"));
var models_1 = require("../../../models");
var PropertyInputWrapper_1 = require("../PropertyInputWrapper");
var AttitudeScale_1 = require("./AttitudeScale");
var model_1 = require("./model");
var NumberAttitudeScaleInput = function (_a) {
    var propertyId = _a.propertyId, errorMessages = _a.errorMessages, className = _a.className, displayError = _a.displayError, disabled = _a.disabled, design = _a.design, scaleStart = _a.scaleStart, scaleEnd = _a.scaleEnd, value = _a.value, leftLabel = _a.leftLabel, centerLabel = _a.centerLabel, rightLabel = _a.rightLabel, onChange = _a.onChange;
    var inputFont = design.colors.inputFont;
    var handleChange = function (e) {
        onChange(e.target.value);
    };
    return (react_1.default.createElement(PropertyInputWrapper_1.PropertyInputWrapper, { propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.number, inputFormatType: models_1.NUMBER_PROPERTY_INPUT_TYPE.additionalText, errorMessages: errorMessages, className: className, displayError: displayError },
        react_1.default.createElement(AttitudeScale_1.AttitudeScale, { radioGroupName: propertyId, scaleNumbers: (0, model_1.createScaleNumbers)(scaleStart, scaleEnd), error: displayError, color: inputFont, disabled: disabled, value: value, leftLabel: leftLabel, centerLabel: centerLabel, rightLabel: rightLabel, onChange: handleChange })));
};
exports.NumberAttitudeScaleInput = NumberAttitudeScaleInput;
